// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3gN1E","col":"styles_col__8IfnC"};